module.exports = __webpack_public_path__ + "static/example-02-square-bac372324f1fb54680ef7eeaf8367f0a.png";